export function populateFileCategories(
  files: any[],
  fileCategories: any[]
): any[] {
  if (!fileCategories || fileCategories.length === 0) return files;
  const categoryMap = new Map(fileCategories.map((c: any) => [c._id, c]));
  return files.map((file: any) => {
    if (typeof file.category === "string") {
      return { ...file, category: categoryMap.get(file.category) || null };
    }
    return file;
  });
}
